<template>
    <div class="auditWork">
        <Header menuName="generateWorkOrder" :keyWord.sync="keyWord" pageName="业务列表" :component.sync="component">
        </Header>
        <Footer :page="0" :mineActive="2"></Footer>
        <div class="workList">
            <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
                    :immediate-check="false" :offset="100">
                    <listItem v-for="(item, index) in tableList" :key="index" :info="item" :type.sync="component"
                        @action="action"></listItem>
                </van-list>
            </van-pull-refresh>
        </div>
        <van-popup v-model="show" round position="bottom">
            <van-picker show-toolbar :columns="columns" @cancel="show = false" @confirm="onConfirm" />
        </van-popup>
    </div>
</template>
<script>
import Footer from "@/components/Footer";
import Header from "@/components/Header2";
import listItem from "./components/item";
import { Dialog } from 'vant';
import { xgBusinessList, xgBusinessListUpdate } from "@/utils/network/interface";
export default {
    name: 'generateWorkOrder',

    data() {
        return {
            keyWord: "",
            component: "",
            refreshing: false,
            loading: false,
            finished: false,
            tableList: [],
            pageInfo: {
                pageSize: 10,
                pageNum: 1,
                total: 0,
            },
            show: false,
            columns: ['生成工单', '不生成工单'],
            workOrderId: null

        }
    },
    methods: {
        getData() {
            console.log("jinlaile");
            let obj = { pageSize: 10, pageNum: 1 };
            let params = {
                name: this.keyWord,
                monitorState: this.component == 'workOrderGenerated' ? 1 : this.component == 'noWorkOrderGenerated' ? 0 : this.component == 'unconfirmed' ? 2 : '',
                ...obj,
            };
            xgBusinessList(params).then((res) => {
                this.refreshing = false;
                this.loading = false;

                if (res.code == 200) {
                    if (res.rows == null || res.rows.length == 0) {
                        this.finished = true;
                        this.loading = false;
                        this.pageInfo.pageNum = 1;
                        this.tableList = [];

                    } else {
                        this.tableList = res.rows;
                        this.pageInfo.pageNum++;
                        this.pageInfo.total = res.total;
                        if (this.tableList.length >= res.total) {
                            this.finished = true;
                        }

                    }
                } else {
                    this.tableList = [];
                }
            })
                .catch((err) => { });

        },
        onRefresh() {
            this.finished = false;
            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.pageInfo.pageNum = 1;
            this.getData();
            // this.pageInfo.pageNum++;
        },
        onLoad() {
            setTimeout(() => {
                const { pageSize, pageNum } = this.pageInfo;
                let obj = { pageSize, pageNum };
                let params = {
                    name: this.keyWord,
                    monitorState: this.component == 'workOrderGenerated' ? 1 : this.component == 'noWorkOrderGenerated' ? 0 : '',
                    ...obj,
                };
                xgBusinessList(params)
                    .then((res) => {
                        if (res.code === 200) {
                            if (res.rows == null || res.rows.length == 0)
                                return (
                                    (this.finished = true),
                                    (this.loading = false),
                                    (this.page.pageNum = 1),
                                    (this.tableList = [])
                                );
                            this.tableList = this.tableList.concat(res.rows);
                            this.pageInfo.pageNum++;
                            this.pageInfo.total = res.total;
                            this.loading = false;
                            if (this.tableList.length >= res.total) {
                                this.finished = true;
                            }
                        } else {
                            this.finished = true;
                        }
                    })
                    .catch((err) => { });
            }, 500);
        },
        action(e) {
            if (e.monitorState == 1 || e.monitorState == 0) {
                Dialog.confirm({
                    title: '提示',
                    message: e.monitorState == 1 ? '你确定要取消工单吗？' : e.monitorState == 0 ? '你确定要生成工单吗？' : '状态异常',
                })
                    .then(() => {
                        console.log("qued");
                        let params = {
                            id: e.id,
                            monitorState: e.monitorState == 1 ? 0 : 1,

                        }
                        // on confirm
                        xgBusinessListUpdate(params).then((res) => {
                            if (res.code == 200) {
                                this.$toast('操作成功');
                                this.getData();
                            } else {
                                this.$toast(res.msg);
                            }
                        })
                            .catch((err) => { });
                    })
                    .catch(() => {

                    });
            } else if (e.monitorState == 2) {
                this.show = true;
                this.workOrderId = e.id;
            }

        },
        onConfirm(item) {
            console.log(item);

            let params = {
                id: this.workOrderId,
                monitorState: item == "生成工单" ? 1 : 0,

            }
            // on confirm
            xgBusinessListUpdate(params).then((res) => {
                if (res.code == 200) {
                    this.$toast('操作成功');
                    this.getData();
                } else {
                    this.$toast(res.msg);
                }
            })
                .catch((err) => { });
            this.show = false;
        }
    },
    watch: {
        keyWord(newVal, oldVal) {
            console.log("初始化");
            // this.finished = false;
            this.pageInfo.pageNum = 1;
            this.tableList = [];
            // this.onLoad();
            this.getData();
            // this.pageInfo.pageNum++;
        },
        component(newVal, oldVal) {
            this.finished = false;
            this.loading = true
            this.keyWord = "";
            this.tableList = [];
            this.pageInfo.pageNum = 1;
            this.getData();
            // this.pageInfo.pageNum++
        },
    },
    components: {
        Footer,
        Header,
        listItem
    }
}
</script>
<style lang="less" scoped>
.auditWork {
    padding-top: 140px;
    padding-bottom: 70px;

    .workList {
        height: 100%;
        min-height: 500px;
    }
}
</style>